import { render, staticRenderFns } from "./UserTariff.vue?vue&type=template&id=67e529a1&scoped=true&lang=pug&"
import script from "./UserTariff.vue?vue&type=script&lang=js&"
export * from "./UserTariff.vue?vue&type=script&lang=js&"
import style0 from "./UserTariff.vue?vue&type=style&index=0&id=67e529a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e529a1",
  null
  
)

export default component.exports